import {
  getUserTimezone,
  handleAggregatorResponseWithHeaders,
} from '@wix/communities-blog-client-common';
import setPosts from '../../../common/actions/set-posts';
import { createPromisifiedAction } from '../../../common/actions-promisifier/create-promisified-action';
import { getQueryLocale } from '../../../common/selectors/locale-selectors';
import { getTotalResults } from '../../../common/services/pagination';
import { getTimezone } from '../../../common/store/basic-params/basic-params-selectors';
import { setIsLoading } from '../../../common/store/is-loading/is-loading-actions';
import { setPostCount } from '../../../common/store/post-count/set-posts-count';
import { MY_POSTS_PAGE_SIZE, getPostStatusByMyPostsPageTab } from '../../constants/my-posts-page';
import { getActiveTab } from '../active-tab/active-tab-selectors';
import { getViewedUserSiteMemberId } from '../viewed-user/viewed-user-selectors';

export const MY_POSTS_ENTITY = 'my-posts';

export const fetchMyPostsPageInitialData = fetchMyPostsPageRenderModel;
const fetchMyPostsPageData = (page = 1) => fetchMyPostsPageRenderModel({ page, fields: ['posts'] });
export const fetchMyPostsPageDataPromisified = createPromisifiedAction(
  fetchMyPostsPageData,
  () => null,
  (response) => response.status,
);

function fetchMyPostsPageRenderModel({ page, fields } = {}) {
  return async (dispatch, getState, { aggregatorRequest }) => {
    const state = getState();
    const language = getQueryLocale(state);
    const siteMemberId = getViewedUserSiteMemberId(state);
    const activeTab = getActiveTab(state);
    const status = getPostStatusByMyPostsPageTab(activeTab);
    const timezone = getTimezone(state) || getUserTimezone();

    dispatch(setIsLoading(MY_POSTS_ENTITY, undefined, true));

    try {
      const { posts } = await aggregatorRequest(
        `/v1/my-posts-page/render-model?${[
          `siteMemberId=${siteMemberId}`,
          `status=${status}`,
          `postLimit=${MY_POSTS_PAGE_SIZE}`,
          `timezone=${timezone}`,
          language && `language=${language}`,
          page && `page=${page}`,
          fields && `fields=${fields.join(',')}`,
        ]
          .filter(Boolean)
          .join('&')}`,
        { throwOnInvalidJson: true },
      );

      const { body, headers } = await handleAggregatorResponseWithHeaders(posts)();
      await dispatch(setPosts(body));
      await dispatch(setPostCount(getTotalResults(headers)));
      dispatch(setIsLoading(MY_POSTS_ENTITY, undefined, false));
    } catch (error) {
      dispatch(setIsLoading(MY_POSTS_ENTITY, undefined, false));
      throw error;
    }
  };
}
